import { render, staticRenderFns } from "./NzFooterContent.vue?vue&type=template&id=553ef9f5"
import script from "./NzFooterContent.vue?vue&type=script&lang=js"
export * from "./NzFooterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports